import { colorConstants } from 'config/colorConstants';
import dayjs from 'dayjs';
import { formatNumWithKMB, formatString, normalizePromoTypeColorMapping } from 'utils/helperMethods';

export const bumpReportTableParser = (
    payload: any = {},
    page: number = 0,
    config: any,
    appConfig: any,
    distinctPromoTypes: any = {},
    attributeLevelsFromConfig: any[] = [],
    attribute_levels: string[] = [],
) => {
    const promoTypeColorMapping: any = normalizePromoTypeColorMapping(config.promoTypeColorMapping);
    const { data, startWeek = [], endWeek = [] } = payload;
    const result: any = [];
    const attributeLevel1 = attributeLevelsFromConfig?.[0];
    const attributeLevel2 = attributeLevelsFromConfig?.[1];
    //console.log(startWeek, endWeek, data, 'logging g');
    if (page === 1)
        result.push({
            ppg: '', //for promo type legends in table
        });
    const weekPercentage = 25;
    const marginBlock = 10;
    const barHeight = 8;
    const weekDivision = 4;
    const promoTypesObj: any = { ...distinctPromoTypes };
    try {
        data.forEach((ppg: any, index: number) => {
            const dim2AttributeNames = attributeLevel2 ? ppg[attributeLevel2?.value].join(', ') : null;
            const tempObj: any = {
                ppg: ` ${ppg[attributeLevel1?.value]}`,
                dim2FormattedName: `${dim2AttributeNames ? '(' + formatString(dim2AttributeNames, 8) + ')' : ''}`,
                dim2AttributeNames,
                // ppg: `${ppg.dim1}`,
                key: ppg[attributeLevel1?.value] + index,
            };
            for (let i = 0; i < endWeek.length; i += weekDivision) {
                tempObj[dayjs(endWeek[i]).format(appConfig?.commonConfig?.dateFormatAlt)] = [];
            }
            // sorting trends in ascending order of startdate
            const sortedArray = ppg.active_trends.slice().sort(function (a: any, b: any) {
                return new Date(a.start_timestamp).getTime() - new Date(b.start_timestamp).getTime();
            });
            let previousEndIndex = 0;
            let startMonthIndexMapping = 0;
            let updatedMarginTop = 0;
            let updatedMarginPrev = 0;
            sortedArray.forEach((trend: any, trendIndex: number) => {
                const starttimestampIndex = Math.max(
                    startWeek.findIndex((date: any) => date === trend.start_timestamp),
                    0,
                );
                const endtimestampIndex = Math.max(
                    endWeek.findIndex((date: any) => date === trend.end_timestamp),
                    0,
                );
                const startMonthIndex = Math.floor(starttimestampIndex / weekDivision) * weekDivision;
                const promoType = String(trend.promo_type).toLowerCase();
                if (!(promoType in promoTypesObj)) {
                    promoTypesObj[promoType] = true;
                }
                const weekDifference = calculateWeeksDifference(starttimestampIndex, endtimestampIndex);
                const marginLeft = calculateWeeksDifference(startMonthIndex, starttimestampIndex) * weekPercentage;
                const width = `calc(${weekDifference * weekPercentage + weekPercentage}% + ${
                    weekDifference / weekDivision
                }px)`;

                //if startdate not in between previous items's month(add extra margin)
                // if (
                //     startMonthIndex !== startMonthIndexMapping &&
                //     starttimestampIndex > startMonthIndexMapping + (weekDivision - 1)
                // ) {
                //     updatedMarginTop = trendIndex * (28 - 10) + marginBlock;
                // } else {
                //     updatedMarginTop = marginBlock;
                // }

                //for index ===0 or if(startmonth index of previous itemis equal to start month index of current item)
                if (trendIndex === 0 || startMonthIndexMapping === startMonthIndex) {
                    updatedMarginTop = marginBlock;
                    updatedMarginPrev += 18; //(padding 10 + height of bar 8)
                    //if starttimestampindex of current item is greater than endtimestamp index of prev item , dont change margin top
                } else if (starttimestampIndex > previousEndIndex) {
                    updatedMarginTop = updatedMarginPrev;
                    //if starttimestampindex of current item is less or equal to endtimestamp index of prev item , change margin top
                } else if (starttimestampIndex <= previousEndIndex) {
                    updatedMarginPrev += 18;
                    updatedMarginTop = updatedMarginPrev;
                }
                previousEndIndex = endtimestampIndex;
                startMonthIndexMapping = startMonthIndex;

                const trendObj = {
                    style: {
                        // marginTop: (trendIndex + 1) * marginBlock + (trendIndex + 1) * barHeight,
                        marginTop: trendIndex === 0 ? marginBlock : updatedMarginTop,
                        background:
                            promoType in promoTypeColorMapping
                                ? promoTypeColorMapping[promoType].color
                                : colorConstants.brown,
                        marginLeft: `${marginLeft}%`,
                        width: width,
                    },
                    infoData: {
                        ...trend,
                        promoMech: trend.promo_mech,
                        promoType:
                            promoType in promoTypeColorMapping ? promoTypeColorMapping[promoType].label : promoType,
                        fieldValue: trend.field_value,
                        startTimestamp: dayjs(trend.start_timestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                        endTimestamp: dayjs(trend.end_timestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                        product: ppg?.[attributeLevel1?.value],
                    },
                    shared: false,
                };
                tempObj[dayjs(endWeek[startMonthIndex]).format(appConfig?.commonConfig?.dateFormatAlt)].push(trendObj);
            });
            result.push(tempObj);
        });
        return { promoTypesObj, result };
    } catch (error) {
        console.log(error, 'logging er');
        throw error;
    }
};

function calculateWeeksDifference(startDateIndex: any, endDateIndex: any) {
    return endDateIndex - startDateIndex || 0;
}
